import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { useNodes } from "../../api/hooks.js";
import {
  Badge,
  Button,
  CenteredSpinner,
  DriverBadge,
  EmptyState,
  ErrorState,
  HealthDot,
  PageHeader,
  table,
} from "../../components/ui.js";
import { NodeDetailDrawer } from "./NodeDetailDrawer.js";
import { RegisterNodeModal } from "./RegisterNodeModal.js";

export function NodesPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const nodes = useNodes();
  const [showRegister, setShowRegister] = useState(false);

  const items = nodes.data ?? [];

  return (
    <div className="p-6 lg:p-8">
      <PageHeader
        eyebrow="Infrastructure"
        title="Nodes"
        subtitle="Media nodes that ingest publishes and serve playback."
        actions={
          <Button variant="primary" onClick={() => setShowRegister(true)}>
            <Plus className="h-4 w-4" /> Register node
          </Button>
        }
      />

      {nodes.isLoading && <CenteredSpinner label="Loading nodes…" />}
      {nodes.error && <ErrorState message={nodes.error.message} />}

      {nodes.data && items.length === 0 && (
        <EmptyState
          title="No nodes registered"
          hint="Register a MediaMTX, SRS, or Cloudflare node to start routing publishes."
        />
      )}

      {items.length > 0 && (
        <div className={table.wrap}>
          <div className={table.scroll}>
            <table className={table.table}>
              <thead className={table.head}>
                <tr>
                  <th className={table.th}>Slug</th>
                  <th className={table.th}>Region</th>
                  <th className={table.th}>Driver</th>
                  <th className={table.th}>Health</th>
                  <th className={table.th}>Live</th>
                </tr>
              </thead>
              <tbody className={table.body}>
                {items.map((n) => (
                  <tr
                    key={n.id}
                    onClick={() => navigate(`/nodes/${n.id}`)}
                    className={table.row}
                  >
                    <td className={table.td}>
                      <div className="flex items-center gap-2">
                        <span className="font-medium text-foreground">
                          {n.slug}
                        </span>
                        {!n.enabled && <Badge tone="amber">disabled</Badge>}
                      </div>
                    </td>
                    <td className={table.td}>
                      <span className="text-muted-foreground">{n.region}</span>
                    </td>
                    <td className={table.td}>
                      <DriverBadge driver={n.driver} />
                    </td>
                    <td className={table.td}>
                      <HealthDot health={n.health} />
                    </td>
                    <td className={table.td}>
                      <span className="tabular-nums text-foreground/80">
                        {n.activeStreamCount}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {id && (
        <NodeDetailDrawer nodeId={id} onClose={() => navigate("/nodes")} />
      )}
      {showRegister && (
        <RegisterNodeModal onClose={() => setShowRegister(false)} />
      )}
    </div>
  );
}
